import type { StudentFundingRequestVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const studentRetrieveFundingRequests = createApiThunk<StudentFundingRequestVM[], void>(
  "fundingRequests/retrieveFundingRequests",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getAllFundingRequests();
  },
);
